import RegattaEntryView from './RegattaEntryView';

export default RegattaEntryView;
